<template>
  <el-card>
    <div v-for="(item, key) in settings" :key="key">
      <div style="font-size: 32px;color: #6c6c6c;" v-if="item.name == 'new-product'">新品速递</div>
      <div style="font-size: 32px;color: #6c6c6c;" v-else-if="item.name == 'piano'">电钢琴</div>
      <div style="font-size: 32px;color: #6c6c6c;" v-else-if="item.name == 'organ'">电子琴</div>
      <el-table class="table block"
                :data="item.value"
                :row-class-name="tableRowClassName"
                v-loading="loading">
        <el-table-column label="广告缩略图" >
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              alt="图片加载失败"
              :src="scope.row.banner"
              v-if="scope.row.banner"
              fit="contain"></el-image>
              <el-image v-else style="width: 100px; height: 100px;">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
          </template>
        </el-table-column>
        <el-table-column label="广告名称">
          <template slot-scope="scope">
            <span v-if="scope.row.name">{{scope.row.name}}</span>
            <span v-else style="color: #d2d2d2;">未编辑内容</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-link type="primary" @click="goEdit(scope.row, item.name)" style="margin-right: 10px;">编辑</el-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash'

  const { mapState } = createNamespacedHelpers('newProductSettings')

  export default {
    data() {
      return {
        loading: true,
        dialogFormVisible: false,
        editModel : { name: '' },
      }
    },
    computed: {
      ...mapState(['settings'])
    },
    methods: {
      tableRowClassName({row, rowIndex}) {
        row.index = rowIndex;
      },
      goEdit(setting, type) {
        const query = { index: setting.index, type}
        this.$router.push({path: '/settings/new-product-edit', query, params: {...setting}})
      }
    },
    async mounted() {
      await this.$store.dispatch('newProductSettings/getSettings')
      this.loading = false
    }
  }
</script>

<style scoped>
  /deep/.el-table {
    margin-bottom: 20px;
  }

  /deep/.el-image .image-slot{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    font-size: 14px;
  }
</style>
